import html from 'text!modules/jquery.depotcv1clickTemplate.html';
import globalScope from 'core/globalScope';
import ga from 'ga';
import $ from 'jquery';
import { trackerDepotCV } from 'modules/abtasty';
import 'jquery.ui.widget';
import 'vendor/jquery.iframe-transport';
import 'jquery.fileupload';
import 'jquery.fileupload-process';
import 'vendor/jquery.fileupload-validate';

function depotcv1click($depotcv1click, customOptions) {
  const document = globalScope.document,
    window = globalScope.window;

  const options = {
    autoUpload: true,
    onInit: function() {},
    onUploadAdd: function() {},
    onUploadStarted: function() {},
    onUploadDone: function() {},
    onUploadFailed: function() {},
    onClientValidationFailed: function() {},
    loadingTemplate: ''
  };

  if (customOptions) {
    $.extend(options, customOptions);
  }

  const formerHtml = $depotcv1click.html();
  $depotcv1click.html(html);

  const $area = $depotcv1click.find('.depotcv1click-area'),
    $input = $depotcv1click.find('.depotcv1click-input'),
    $feedback = $depotcv1click.find('.depotcv1click-feedback'),
    $error = $depotcv1click.find('.depotcv1click-errors'),
    $loading = $depotcv1click.find('.depotcv1click-loading');

  $loading.html(options.loadingTemplate);
  $area.prepend(formerHtml);
  $loading.hide();

  options.onInit();

  $input
    .fileupload({
      url: `${globalScope.domainUrlCadremploi}/emploi/candidate/ajax/uploadCV`,
      type: 'POST',
      autoUpload: options.autoUpload,
      formAcceptCharset: 'iso-8859-1',
      acceptFileTypes: /(\.|\/)(doc|pdf|docx|rtf)$/i,
      maxFileSize: 3145728, // 3 Mo
      messages: {
        uploadedBytes: 'Les octets telecharges depassent la taille du fichier',
        acceptFileTypes:
          '<span class="icon-validation-error"></span> Hum... le chargement de votre CV a &eacute;chou&eacute;. Merci de recommencer',
        maxFileSize: "Le fichier que vous tentez d'envoyer depasse la taille maximale autorisee"
      },
      xhrFields: {
        withCredentials: true
      }
    })
    .on('fileuploadadd', function(e, data) {
      $.each(data.files, function(index, file) {
        $feedback.html(file.name);
      });
      options.onUploadAdd();
    })
    .on('fileuploadprocessalways', function(e, data) {
      const index = data.index,
        file = data.files[index];
      if (file.error) {
        $error.html('<p class="alert-box new-warning">' + file.error + '</p>');
        options.onClientValidationFailed();
      } else {
        $error.html('');
        $loading.show();
        $area.hide();
        options.onUploadStarted();
        $('.depotcv1click-feedback').hide();
      }
    })
    .on('fileuploaddone', function(e, data) {
      let result = data.result;
      if (result[0] && result[0].body) {
        // Obligatoire pour IE 7, 8, 9
        result = $(result[0]).text();
      }
      processServerResult(result);
      $loading.hide();
    })
    .on('fileuploadfail', function(e, data) {
      const result = data.jqXHR.responseText;
      const msg = $.parseJSON(result);
      if (msg.error) {
        $error.html('<p class="alert-box new-warning">' + msg.error + '</p>');
      } else {
        $error.html('<p class="alert-box new-warning">Erreur inconnue</p>');
      }
      $area.show();
      $loading.hide();
      options.onUploadFailed();
    })
    .on('click', function() {
      trackerClicCvPickerGA();
    });

  function trackerClicCvPickerGA() {
    if (customOptions.source === 'edito') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_edito');
    } else if (customOptions.source === 'home') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_bulle_hp');
    } else if (customOptions.source === 'detail_offre') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_footer_detail');
    } else if (customOptions.source === 'liste_offres') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_bloc_liste');
    } else if (customOptions.source === 'upload_cv') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_profil');
    } else if (customOptions.source === 'landing_depot_cv') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_landing_page');
    } else if (customOptions.source === 'onboarding_page') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_onboarding_page');
    } else if (customOptions.source === 'regions') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_carte_regions');
    } else if (customOptions.source === 'cabinets') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_liste_cabinets');
    } else if (customOptions.source === 'pages_statiques') {
      ga.sendEvent('navigation', 'clic_cv_picker', 'via_pages_statiques');
    } else {
      ga.deprecatedSendEvent('navigation', 'clic_cv_picker');
    }
  }

  function trackerDepotCvGA() {
    if (customOptions.source === 'edito') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_edito');
    } else if (customOptions.source === 'home') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_bulle_hp');
    } else if (customOptions.source === 'detail_offre') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_footer_detail');
    } else if (customOptions.source === 'liste_offres') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_bloc_liste');
    } else if (customOptions.source === 'upload_cv') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_profil');
    } else if (customOptions.source === 'landing_depot_cv') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_landing_page');
    } else if (customOptions.source === 'onboarding_page') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_onboarding_page');
    } else if (customOptions.source === 'regions') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_carte_regions');
    } else if (customOptions.source === 'cabinets') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_liste_cabinets');
    } else if (customOptions.source === 'pages_statiques') {
      ga.sendEvent('depot_cv', 'depot_cv', 'via_pages_statiques');
    } else {
      ga.deprecatedSendEvent('depot_cv', 'depot_cv');
    }
  }

  function processServerResult(serverResult) {
    trackerDepotCvGA();
    if (serverResult.urlRedirect) {
      trackerDepotCV();
      options.onUploadDone();
      window.setTimeout(function() {
        document.location.href = serverResult.urlRedirect;
      }, 300);
    } else {
      if (serverResult.error) {
        $error.html('<p class="alert-box new-warning">' + serverResult.error + '</p>');
      } else {
        $error.html('<p class="alert-box new-warning">Erreur inconnue</p>');
      }
      options.onUploadFailed();
      $loading.hide();
      $area.show();
    }
  }
}

// exposition sous forme de module jQuery
$.fn.extend({
  depotcv1click: function(customOptions) {
    return this.each(function() {
      depotcv1click($(this), customOptions);
    });
  }
});

export default depotcv1click;
